module.exports = __webpack_public_path__ + "static/img/iconfont.dd9aa51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconfont.svg
// module id = PayV
// module chunks = 8